import { createFeatureSelector, createSelector } from '@ngrx/store';
import { staticFormFeatureKey, StaticFormState } from './static-form.reducer';

const selectFormFeatureState = createFeatureSelector<StaticFormState>(staticFormFeatureKey);

export const selectIsLoading = createSelector(selectFormFeatureState, (state) => state.isLoading);
export const selectIsEditMode = createSelector(selectFormFeatureState, (state) => state.isEditMode);
export const selectTypeName = createSelector(selectFormFeatureState, (state) => state.typeName);
export const selectFormType = createSelector(selectFormFeatureState, (state) => state.formType);
export const selectCurrentPage = createSelector(selectFormFeatureState, (state) => state.currentPage);
export const selectPageCountTotal = createSelector(selectFormFeatureState, (state) => state.pageCountTotal);
export const selectVisiblePages = createSelector(selectFormFeatureState, (state) => state.visiblePages);
export const selectFormPageNumber = createSelector(
  selectCurrentPage,
  selectVisiblePages,
  (currentPage, visiblePages) => {
    return { currentPage, visiblePages };
  }
);
export const selectErrorCount = createSelector(selectFormFeatureState, (state) => state.errorCount);
export const selectCompletedForm = createSelector(selectFormFeatureState, (state) => state.completedForm);
export const selectIsPostRegister = createSelector(selectFormFeatureState, (state) => state.isPostRegister);

export const selectIsLastPage = createSelector(
  selectFormFeatureState,
  (state) => state.currentPage === state.pageCountTotal || state.currentPage === state.visiblePages?.slice(-1)?.pop()
);
export const selectValidationRequest = createSelector(selectFormFeatureState, (state) => state.validationRequest);
export const selectCheckValidation = createSelector(
  selectValidationRequest,
  selectCurrentPage,
  (isValidating, currentPage) => {
    return { isValidating, currentPage };
  }
);
export const selectPageIsValidated = createSelector(
  selectErrorCount,
  selectValidationRequest,
  (errors, isValidating) => {
    return { errors, isValidating };
  }
);
export const selectLastValidatedPage = createSelector(selectFormFeatureState, (state) => state.lastValidatedPage);
export const selectHasChanges = createSelector(selectFormFeatureState, (state) => state.hasChanges);
export const selectPaginationVisible = createSelector(selectFormFeatureState, (state) => state.paginationVisible);
export const selectShowAllPages = createSelector(selectFormFeatureState, (state) => state.showAllPages);
export const selectIsPerformView = createSelector(selectFormFeatureState, (state) => state.isPerformView);
export const selectIsCareProvider = createSelector(selectFormFeatureState, (state) => state.isCareProvider);
export const selectQuestionsForValidation = createSelector(
  selectFormFeatureState,
  (state) => state.questionsToValidate
);

export const selectShouldStopBeforeSaving = createSelector(
  selectFormFeatureState,
  (state) => state.shouldStopBeforeSaving
);
export const selectStoppedBeforeSaving = createSelector(selectFormFeatureState, (state) => state.stoppedBeforeSaving);
export const selectShouldForceSave = createSelector(selectFormFeatureState, (state) => state.shouldForceSave);

export const selectShouldStopBeforeUpdating = createSelector(
  selectFormFeatureState,
  (state) => state.shouldStopBeforeUpdating
);
export const selectStoppedBeforeUpdating = createSelector(
  selectFormFeatureState,
  (state) => state.stoppedBeforeUpdating
);
export const selectShouldForceUpdate = createSelector(selectFormFeatureState, (state) => state.shouldForceUpdate);

export const selectShouldStopBeforeDrafting = createSelector(
  selectFormFeatureState,
  (state) => state.shouldStopBeforeDrafting
);
export const selectStoppedBeforeDrafting = createSelector(
  selectFormFeatureState,
  (state) => state.stoppedBeforeDrafting
);
export const selectShouldForceDraft = createSelector(selectFormFeatureState, (state) => state.shouldForceDraft);

export const selectShouldStopBeforeNextPage = createSelector(
  selectFormFeatureState,
  (state) => state.shouldStopBeforeNextPage
);
export const selectNextPageButtonClicked = createSelector(
  selectFormFeatureState,
  (state) => state.nextPageButtonClicked
);
export const selectSaveButtonClicked = createSelector(selectFormFeatureState, (state) => state.saveButtonClicked);

export const selectOnNextPage = createSelector(selectFormFeatureState, (state) => state.onNextPage);
export const selectOnPreviousPage = createSelector(selectFormFeatureState, (state) => state.onPreviousPage);
export const selectAdditionalQuestionsToConvert = createSelector(
  selectFormFeatureState,
  (state) => state.additionalQuestionsToConvert
);

export const selectIsPrinting = createSelector(selectFormFeatureState, (state) => state.isPrinting);

export const selectSaveDraftCompleted = createSelector(selectFormFeatureState, (state) => state.saveDraftCompleted);
export const selectSaveDraftFailed = createSelector(selectFormFeatureState, (state) => state.saveDraftFailed);

export const selectShouldFocusFormName = createSelector(selectFormFeatureState, (state) => state.shouldFocusFormName);

export const selectJournalizationDisabled = createSelector(
  selectFormFeatureState,
  (state) => state.journalizationDisabled
);

export const selectNextPageLabel = createSelector(selectFormFeatureState, (state) => state.nextPageLabel);

export const selectCustomErrorMessages = createSelector(selectFormFeatureState, (state) => state.customErrorMessages);
